import React, { useEffect, useState } from 'react'
import {
  // ArrowIcon,
  CoatOfArms,
  ContactFormImage,
  EnuguIRS,
  EnuguState,
  // HeaderBadge,
  HomeBannerimage,
  Services1,
  Services2,
  Services3,
  Services4,
  Services5,
  Services6,
  Services7,
  WhoWeAre
} from '../../assets'
import style from './style.module.css'
import { Button } from '../../components/buttons'
import { ServicesCard } from '../../components/cards'
import { Input, TextArea } from '../../components/inputs'
import axios from 'axios'
import Alert from '../../components/alert'

const url = "https://alpha3.norlics.ng/api/norlicsDigitalMsg/message"

const Home = () => {
  const [strip, setStrip] = useState('vision');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    emailAddress: '',
    message: ''
  });

  const [alert, setAlert] = useState({
    showing: false,
    type: null,
    message: ""
  });

  const handleInputUpate = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value })
  }

  const handleFormSubmition = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);

    if (Object.values(formData).includes('')) {
      setAlert({
        showing: true,
        type: "error",
        message: "All fields are required."
      });
      setLoading(false);
      return;
    }

    axios.post(url, formData)
      .then((response) => {
        setFormData({
          firstName: '',
          lastName: '',
          phoneNumber: '',
          emailAddress: '',
          message: ''
        })

        setAlert({
          showing: true,
          type: "success",
          message:
            response?.data?.message ??
            "Successful!"
        });
      })
      .catch((error) => {
        setAlert({
          showing: true,
          type: "error",
          message:
            error?.response?.data?.errors?.details[0]?.message ??
            "There was an error. Please try again!"
        });
      })
      .finally(() => {
        setLoading(false);
      })
  }

  useEffect(() => {
    const delay = setTimeout(
      () =>
        setAlert({
          showing: false,
          type: null,
          message: ""
        }),
      3000
    );

    return () => clearTimeout(delay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!alert.showing]);

  return (
    <>
      {alert.showing && <Alert text={alert.message} type={alert.type} />}
      <main>
        <header>
          <div className={style.header__deets}>
            <h2>
              We are a Global Network Committed to <span>Clients Success</span>
            </h2>
            <p>
              We emphasize the importance of understanding and prioritizing clients' needs, goals, and desired outcomes to help them achieve their objectives effectively.
            </p>
            {/* <Button
              children={<>
                Book Consultation Now
                <ArrowIcon />
              </>}
            /> */}
          </div>
          <div className={style.header__image}>
            {/* <div className={style.header__image_badge}>
              <HeaderBadge />
              <div>
                <p>20,000+ Ratings</p>
                <p>Lorem ipsum dolor sit amet</p>
              </div>
            </div> */}
            <img
              src={HomeBannerimage}
              alt='Satisfied clients'
            />
          </div>
        </header>

        <div className={style.header__leaders}>
          <p>Industry leaders trust Norlics Digital Services to grow their revenue</p>
          <div className={style.header__leaders_images}>
            <img
              src={CoatOfArms}
              alt='Coat of arms'
            />
            <img
              src={EnuguIRS}
              alt='Enugu IRS Logo'
            />
            <img
              src={EnuguState}
              alt='Enugu State Logo'
            />
            {/* <img
              src={EnuguIRS}
              alt='Enugu IRS Logo'
            /> */}
            {/* <img
              src={EnuguState}
              alt='Enugu State Logo'
            /> */}
            {/* <img
              src={EnuguIRS}
              alt='Enugu IRS Logo'
            /> */}
            {/* <img
              src={CoatOfArms}
              alt='Coat of arms'
            /> */}
          </div>
        </div>

        <section className={style.whoWeAre}>
          <div className={style.whoWeAre__wrapper}>
            <div className={style.whoWeAre__deets}>
              <p className={style.small}>About Us</p>
              <h3>Who we are</h3>
              <p>
                Norlics is an ICT services company with focus on IT Consulting and Advisory, Payment Solutions, Cloud Computing, IT Governance, Infrastructure Services, Application development and Information Security. In addition, we also offer website development and Digital Marketing services.
              </p>
              <p>
                We have been in existence since September, 2018 but boasts of an accumulated staff experience of over 20 years in providing IT services to customers in various business categories in Nigeria. We are inspired by the simple belief that there are no issues that do not have solutions.
              </p>

              <div className='mb-40' />

              <div className={[
                style.whoWeAre__deets_strip,
                strip === 'vision' ? style.activated : ''
              ].join(' ')}
                onClick={() => setStrip('vision')}
              >
                <h4>Our vision</h4>
                <p>
                  To be a leading global firm by continuously offering best in class products and services to exceed the expectations and needs of our teaming clientele.
                </p>
              </div>
              <div className={[
                style.whoWeAre__deets_strip,
                strip === 'mission' ? style.activated : ''
              ].join(' ')}
                onClick={() => setStrip('mission')}
              >
                <h4>Our Mission</h4>
                <p>
                  To exemplify professionalism by efficiently delivering niche products and services to create an edge for our customers.
                </p>
              </div>
              <div className={[
                style.whoWeAre__deets_strip,
                strip === 'mantra' ? style.activated : ''
              ].join(' ')}
                onClick={() => setStrip('mantra')}
              >
                <h4>Our Mantra</h4>
                <p>
                  Greatness in service. This is borne out of our passion and desire to make a difference in all our undertakings
                </p>
              </div>
            </div>
            <div className={style.whoWeAre__image}>
              <img src={WhoWeAre} alt='Who we are' />
            </div>
          </div>
        </section>

        <section className={style.services}>
          <div className={style.services__deets}>
            <p className={style.hightlights}>Services</p>
            <h3>
              <span className={style.hightlights}>Norlics Digital Services</span> focus basically
              on automation of the Internally generate revenue for Enugu State and as a subsidiary of Norlics Ltd.
            </h3>
            <p>This system provides the following functionalities:</p>
          </div>

          <div className={style.services__cards}>
            <ServicesCard
              image={Services1}
              header='Efficient and Quality Tax Collection and Management'
              description="These are the processes and practices that ensure tax revenues are collected effectively and transparently, while minimizing errors and maximizing compliance. We tend to balance the need for improved revenue collection with the taxpayer's experience, promoting compliance and fairness."
            />
            <ServicesCard
              image={Services2}
              header='Diversified Tax Data Reporting Channel'
              description="This encompasses a variety of methods and platforms through which taxpayers and businesses can report their tax information and comply with tax obligations. This approach enhances accessibility, efficiency, and accuracy in tax reporting. We aim to create a more flexible, user-friendly, and efficient tax reporting system, benefiting both taxpayers and tax authorities."
            />
            <ServicesCard
              image={Services3}
              header='Unified Tax Data Interface Standard'
              description="This is a standardized framework or set of protocols that facilitates the consistent exchange of tax-related data between various stakeholders, such as taxpayers, businesses, tax authorities, and third-party service providers. This standardization aims to streamline tax reporting, enhance data accuracy, and improve compliance, benefiting all parties and leading to effective tax administration."
            />
            <ServicesCard
              image={Services4}
              header='Unified Tax Portal Platform Operating System'
              description="This is a comprehensive system designed to centralize and streamline tax-related processes for taxpayers, businesses, and tax authorities. The platform serves as an integrated hub where all tax-related activities—filing, payments, reporting, and communication—can be managed efficiently. It enhances the overall tax experience for all stakeholders, promoting compliance and improving government revenue collection."
            />
            <ServicesCard
              image={Services5}
              header='Multitier Tax Data Management System'
              description="This architectural framework is designed to manage tax-related data across multiple layers, ensuring scalability, flexibility, and security. It caters to the diverse needs of taxpayers, businesses, and tax authorities, providing a robust system for efficiently handling tax data."
            />
            <ServicesCard
              image={Services6}
              header='Real-time Tax Analyzing and Warning Mechanism'
              description="This is a system designed to monitor tax-related data continuously and provide immediate alerts or insights to users—such as taxpayers, businesses, and tax authorities—about compliance issues, potential discrepancies, or deadlines. This mechanism leverages advanced technologies such as data analytics, machine learning, and real-time data processing to enhance tax compliance and decision-making with the view to contributing to improved tax administration and reduced risks by providing real-time feedback, the system enhances transparency and supports more accurate tax reporting."
            />
            <ServicesCard
              image={Services7}
              header='Excellent Security with Authentication Authorization, Encryption & Protection'
              description={<>
                We adopt a comprehensive approach that encompasses <strong>authentication</strong>, <strong>authorization</strong>, <strong>encryption</strong>, and <strong>data protection</strong> creating a robust security framework for a tax data management system. By so doing, we reduce the risk of data breaches, ensure compliance, and protect sensitive taxpayer information effectively.
              </>}
            />
          </div>
        </section>
        {/* <section class={style.consultation}>
          <div className={style.consultation__deets}>
            <h2>Lorem ipsum dolor sit amet, consectetur</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.</p>
            <Button
              children={'Book Consultation'}
            />
          </div>
        </section> */}
        <section className={style.contact__form}>
          <div className={style.contact__form_wrapper}>
            <div className={style.contact__form_content}>
              <div className={style.contact__form_deets}>
                <p className={style.hightlights}>Services</p>
                <h4>Leave us a message</h4>
                <p>Please enter the details of your request. A member of our support staff will respond as soon as possible.</p>
              </div>
              <form onSubmit={handleFormSubmition}>
                <div className={style.double__input}>
                  <div>
                    <Input
                      label='First name'
                      fieldName='firstName'
                      value={formData.firstName}
                      onChange={handleInputUpate}
                    />
                  </div>
                  <div>
                    <Input
                      label='Last name'
                      fieldName='lastName'
                      value={formData.lastName}
                      onChange={handleInputUpate}
                    />
                  </div>
                </div>
                <div className={style.double__input}>
                  <div>
                    <Input
                      label='Email Address'
                      fieldName='emailAddress'
                      value={formData.emailAddress}
                      onChange={handleInputUpate}
                    />
                  </div>
                  <div>
                    <Input
                      label='Phone number'
                      fieldName='phoneNumber'
                      value={formData.phoneNumber}
                      onChange={handleInputUpate}
                    />
                  </div>
                </div>
                <div>
                  <TextArea
                    label='Message'
                    fieldName='message'
                    value={formData.message}
                    row={2}
                    onChange={handleInputUpate}
                  />
                </div>
                <Button
                  disabled={loading}
                  children={loading ? 'Submitting...' : 'Submit'}
                />
              </form>
            </div>
            <div className={style.contact__form_image}>
              <img src={ContactFormImage} alt='Three people in a corporate handshake, smiling.' />
            </div>
          </div>
        </section>

        <section className={style.contact__map}>
          <div className={style.contact__map_wrapper}>
            <div className={style.contact__map_wrapper_map}>
              <iframe title='googleMap' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4460.078308149859!2d7.497474575499415!3d6.456360393535159!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1044a3c101f0940d%3A0x4fcb555640065015!2sFidelity%20Estate%2C%2032%20Prince%20Paul%20Nnaji%20Cres%2C%20GRA%2C%20Enugu%20400102%2C%20Enugu!5e1!3m2!1sen!2sng!4v1726840434274!5m2!1sen!2sng" width="600" height="450" style={{ width: '100%' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div className={style.contact__map_wrapper_deets}>
              <p className={style.hightlights}>Our Location</p>
              <h4>Connecting Near and Far</h4>
              <p className={style.contact__map_address_title}>Enugu Office Addresss</p>
              <p>
                Plot O, Trinity House, Apartment B, Fidelity Estate, Okpara Avenue, Enugu
              </p>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

export default Home